<template>
  <div>
    <!-- <Aftermarket v-if="isshow == 1" @show1="showflow"></Aftermarket> -->
    <Aftermarket
      v-if="roleperson.role == 1 && roleperson.refundState == 0"
      :details="details"
      @show1="showflow"
    ></Aftermarket>
    <!-- <reimburse
      v-if="isshow == 2"
      :afterSaleId=afterSaleId
      @show2="showflow2"
      @show3="showflow3"
      @show4="showflow4"
    ></reimburse> -->
    <reimburse
      v-if="
        (roleperson.role == 2 && roleperson.refundState == 1) ||
          (roleperson.role == 1 && roleperson.refundState == 1)
      "
      :afterSaleId="afterSaleId"
      @show2="showflow2"
      @show3="showflow3"
      @show4="showflow4"
    ></reimburse>
    <!-- <finish v-if="isshow == 3" :dataid2="data" :finish="finish"></finish> -->
    <finish
      v-if="
        roleperson.refundState == 2 ||
          roleperson.refundState == 3 ||
          roleperson.refundState == 4
      "
      :afterSaleId="afterSaleId"
    ></finish>
    <!-- :finish="finish" -->
  </div>
</template>

<script>
import Aftermarket from './components/Aftermarket/index.vue'
import reimburse from './components/reimburse/index.vue'
import finish from './components/finish/index.vue'
import { getparticulars, disposeInfo } from '@/api/refund/index'
export default {
  components: {
    Aftermarket,
    reimburse,
    finish
  },
  data() {
    return {
      roleperson: {},
      details: '',
      afterSaleId: ''
      // finish: ''
    }
  },
  created() {
    this.orderdetails()
    this.reimbursemoney()
  },
  methods: {
    showflow(res) {
      this.afterSaleId = res
      this.roleperson.refundState = 1
      this.roleperson.role = 1
      console.log(this.afterSaleId)
    },
    // 同意退款
    showflow2(res) {
      // this.finish = res
      this.roleperson.refundState = 4
      // console.log(this.finish)
    },
    // 拒绝退款
    showflow3(res) {
      this.roleperson.refundState = 2
      // this.finish = res
      // console.log(this.finish)
    },
    // 撤销申请
    showflow4(res) {
      this.roleperson.refundState = 3
      // this.finish = res
      // console.log(this.finish)
    },
    // 正常流程
    async orderdetails() {
      this.details = this.$route.query.details
      // const res = await getparticulars('1481149227587796994')
      if (this.details) {
        const res = await getparticulars({orderId:this.details,type:1})
        console.log(res)
        if (res.status) {
          this.roleperson = res.data
          // this.roleperson.role = 2
          // this.roleperson.refundState = 2
          this.afterSaleId = res.data.afterSaleId
        }
      } else {
        return false
      }
    },
    // 退款订单
    async reimbursemoney() {
      this.drawback = this.$route.query.drawback
      if (this.drawback) {
        const res = await disposeInfo(this.drawback+'/1')
        console.log(res)
        if (res.status) {
          this.roleperson = res.data
          this.afterSaleId = res.data.afterSaleId
          // this.roleperson.role = 2
          // this.roleperson.refundState = 2
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
